import { useMutation } from '@tanstack/react-query'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../index'

const { env } = window

const useValidateTenantUrlSlugMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()

  const validateTenantUrlSlug = async (urlSlug) => {
    const url = encodeURI(`${env.apiUrl}/tenants/urlSlug/${urlSlug}`)
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.json()
  }

  return useMutation({
    mutationFn: ({ urlSlug }) => validateTenantUrlSlug(urlSlug),
    onError: (error) => handleError(error, 'Error validating project settings')
  })
}

export { useValidateTenantUrlSlugMutation }
